import { memo } from 'react'

import { Autocomplete, Chip, Paper, Stack, TextField, Typography } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import type { ConfigFormValues } from '../types'

const PanelRaw = () => {
  const { t } = useTranslation(['common', 'domain'])

  const { control } = useFormContext<ConfigFormValues>()

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="heading-md" sx={{ mb: 2 }}>
        {t('domain:Workspace.Event.ConfigEditor.general')}
      </Typography>
      <Stack spacing={3}>
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <TextField {...field} size="small" label={t('domain:Workspace.Event.ConfigEditor.displayName')} />
          )}
        />
        <Controller
          control={control}
          name="tags"
          render={({ field }) => (
            <Autocomplete
              multiple
              freeSolo
              options={[] as string[]}
              value={field.value ?? []}
              onChange={(_, value) => field.onChange(value)}
              renderTags={(value, getTagProps) =>
                value.map((option, index) => {
                  const { key, ...tagProps } = getTagProps({ index })
                  return <Chip key={key} size="small" label={option} {...tagProps} />
                })
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={t('domain:Workspace.Event.ConfigEditor.tags')}
                  placeholder={t('domain:Workspace.Event.ConfigEditor.addTag')}
                />
              )}
            />
          )}
        />
        <Controller
          control={control}
          name="fixtureId"
          render={({ field }) => (
            <TextField
              {...field}
              size="small"
              sx={{ maxWidth: 320 }}
              label={t('domain:Workspace.Event.ConfigEditor.fixtureId')}
            />
          )}
        />
      </Stack>
    </Paper>
  )
}

export const Panel = memo(PanelRaw)
